export enum ProductTypeEnum {
  ALCOHOL = 'alcohol',
  FOOD = 'food'
}